import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { TooltipOverflowList } from "../TooltipOverflowList/TooltipOverflowList";

import type { TeamScoringSummaryLine } from "./buildTeamScoringSummaryLines";

type TeamScoringTooltipContentProps = {
    lines: readonly TeamScoringSummaryLine[];
    dataAutomation: string;
};

/** Tooltip body listing a team's scoring rules as a priority tier above its business context. */
export const TeamScoringTooltipContent = ({ lines, dataAutomation }: TeamScoringTooltipContentProps) => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="12px"
            maxWidth="280px"
            maxHeight="400px"
            overflow="auto"
            data-automation={dataAutomation}
        >
            <TooltipOverflowList
                lines={lines}
                moreLabelKey="si.management.teams.column.lead_scoring.more"
                renderLine={(line) => (
                    <Stack
                        key={line.id}
                        gap="2px"
                    >
                        <Text
                            fontVariant="listItem4"
                            color={colorsPalettes.carbon[0]}
                        >
                            {translate(line.priorityLabelKey)}
                        </Text>
                        {line.description ? (
                            <Text
                                fontVariant="tooltip"
                                color={colorsPalettes.carbon[0]}
                            >
                                {line.description}
                            </Text>
                        ) : null}
                    </Stack>
                )}
            />
        </Stack>
    );
};
